import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LabMed = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.082 1.802a6.042 6.042 0 0 0-8.608 0L26.867 8.41l-1.502-1.402c-.7-.7-1.801-.7-2.502 0l-3.203 3.204c-.701.7-.701 1.802 0 2.502l1.501 1.502L7.347 28.032a5.972 5.972 0 0 0-1.702 5.206l-4.504 4.505c-1.402 1.401-1.402 3.804 0 5.206 1.401 1.401 3.804 1.401 5.205 0l4.505-4.505c1.801.3 3.803-.3 5.205-1.702L29.97 22.826l1.502 1.502c.7.7 1.801.7 2.502 0l3.203-3.204c.7-.7.7-1.802 0-2.503l-1.501-1.502 6.606-6.607c2.203-2.503 2.203-6.307-.2-8.71ZM14.254 35.24c-1 1.001-2.502 1.402-3.804 1.001l-.6-.1-5.306 5.306c-.6.6-1.601.6-2.202 0-.6-.6-.6-1.602 0-2.202l5.305-5.306-.1-.601c-.3-1.302 0-2.803 1.001-3.804l2.203-2.203h11.411l-7.908 7.909Zm10.11-10.011H12.953l9.51-9.511 5.705 5.706-3.804 3.805ZM33.774 37.843c-.2-.6-.5-1.302-.801-2.002a79.737 79.737 0 0 0-1.802-3.905c-.7-1.301-2.502-1.301-3.103 0a79.636 79.636 0 0 0-1.802 3.905c-.3.7-.5 1.401-.8 2.002-.2.6-.3 1.201-.3 1.702 0 2.503 2.001 4.405 4.404 4.405 2.402 0 4.404-2.002 4.404-4.405.1-.5-.1-1.101-.2-1.702Zm-4.104 4.105c-1.302 0-2.403-1.102-2.403-2.303 0-.2.1-.5.2-1.101.2-.5.4-1.202.701-1.802.4-1.101 1.001-2.203 1.402-3.104.4.901 1 2.003 1.401 3.104.3.7.5 1.301.7 1.802.2.6.2.9.2 1.101.101 1.201-1 2.303-2.201 2.303Z"
  }));
});
LabMed.displayName = 'LabMed';
LabMed.defaultProps = {
  'aria-label': 'LabMed'
};
export default LabMed;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/LabMed.js
// module id = 3651
// module chunks = 11